// extracted by mini-css-extract-plugin
export default {"deleteButton":"styles_deleteButton__YS6ZY","deleteButtonText":"styles_deleteButtonText__3A+oC"};